import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ItemContext } from "../../Context/ItemContext";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createItem, updateItem } from "../../actions/itemActions";
import { useSnackbar } from "react-simple-snackbar";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
  inputStyle: {
    width: "100%",
    fontFamily:"kruti-101"
  },
}));

const DialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = (props) => {
  const classes = useStyles();
  return <MuiDialogContent {...props} />;
};

const DialogActions = (props) => {
  const classes = useStyles();
  return <MuiDialogActions {...props} />;
};

const AddItem = ({ setOpen, open }) => {
  const classes = useStyles();
  const location = useLocation();
  const [itemData, setItemData] = useState({
    itemName: "",
    unitPrice: "",
    // quantity: "",
    weight: "",
    itemId: [],
  });
  const { itemId, setItemId } = useContext(ItemContext);
  const dispatch = useDispatch();
  const item = useSelector((state) =>
    itemId ? state.items.items.find((i) => i._id === itemId) : null
  );
  const [isEditMode, setIsEditMode] = useState(false); // New state variable
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [errors, setErrors] = useState({});

  const handleSubmitItem = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (itemId) {
        dispatch(updateItem(itemId, itemData, openSnackbar));
        
      } else {
        dispatch(createItem(itemData, openSnackbar));
      }
      clear();
      handleClose();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear the error for the specific field
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (itemData.itemName.trim() === "") {
      newErrors.itemName = "Item name is required";
      isValid = false;
    }
    if (itemData.unitPrice.trim() === "") {
      newErrors.unitPrice = "Unit price is required";
      isValid = false;
    }
    // if (itemData.quantity.trim() === "") {
    //   newErrors.quantity = "Quantity is required";
    //   isValid = false;
    // }
    if (itemData.weight.trim() === "") {
      newErrors.weight = "Weight is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const clear = () => {
    setItemData({ itemName: "", unitPrice: "", weight: "", itemId: [] });
    setErrors({});
  };
  useEffect(() => {
    if (item) {
      // When editing an item, set the form data and switch to edit mode
      setItemData(item);
      setIsEditMode(true);
    } else {
      // When opening for a new item, reset the form and switch to add mode
      clear();
      setIsEditMode(false);
    }
  }, [item, open]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  // useEffect(() => {
  //   var checkId = user?.result?._id;
  //   if (checkId !== undefined) {
  //     setItemData({ ...itemData, itemId: [checkId] });
  //   } else {
  //     setItemData({ ...itemData, itemId: [user?.result?.googleId] });
  //   }
  // }, [location]);

  const handleClose = () => {
   
    setItemData({ itemName: "", unitPrice: "", weight: "", itemId: [] });
    setErrors({});
    setOpen(false);
  };

  return (
    <div>
      <Dialog
         onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          style={{ paddingLeft: "20px", color: "white",backgroundColor: "#ef7f1a" }}
        >
          {itemId? "Edit Item" : "New Item"}
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Name"
                variant="outlined"
                className={classes.inputStyle}
                name="itemName"
                type="text"
                required
                onChange={handleChange}
                value={itemData.itemName}
                error={!!errors.itemName} // Check if error exists
                helperText={errors.itemName} // Display error message
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Price"
                variant="outlined"
                className={classes.inputStyle}
                name="unitPrice"
                type="number"
                required
                onChange={handleChange}
                value={itemData.unitPrice}
                error={!!errors.unitPrice} // Check if error exists
                helperText={errors.unitPrice} // Display error message
              />
            </Grid>
           
            {/* <Grid item xs={12} sm={6}>
              <TextField
                label="Quantity"
                variant="outlined"
                className={classes.inputStyle}
                name="quantity"
                type="number"
                required
                onChange={handleChange}
                value={itemData.quantity}
                error={!!errors.quantity} // Check if error exists
                helperText={errors.quantity} // Display error message
              />
            </Grid> */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Weight"
                variant="outlined"
                className={classes.inputStyle}
                name="weight"
                type="text"
                required
                onChange={handleChange}
                value={itemData.weight}
                error={!!errors.weight} // Check if error exists
                helperText={errors.weight} // Display error message
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleSubmitItem}
            variant="contained"
            style={{ marginRight: "25px" ,backgroundColor: "#ef7f1a",color: "white" }}
          >
            Save Item
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddItem;
